<style></style>
<template>
  <div class="autographList-box">
    <p class="title">短信配置&nbsp;&nbsp;<strong>[ 签名 ]</strong></p>
    <tips></tips>
    <div class="addBtn">
      <el-button type="primary" style="padding:8px 12px" @click="creatAutograph">
        <i class="el-icon-circle-plus"></i>&nbsp;创建签名
      </el-button>
    </div>
    <el-table :data="autographData" border>
      <el-table-column label="签名"  prop="signName"></el-table-column>
      <el-table-column label="审核资料" width="80">
        <template slot-scope="scope">
          <img :src="scope.row.signPicUrl" width="50" height="50"/>
        </template>
      </el-table-column>
      <el-table-column label="申请原因" prop="signReason"></el-table-column>
      <el-table-column label="用户名称" prop="userName"></el-table-column>
      <el-table-column label="是否公用" width="80">
        <template slot-scope="scope">
          <p>{{scope.row.isPublic?'公用':'不公用'}}</p>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" width="80">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isAuditing == 0">通过</el-tag>
          <el-tag type="warning" v-else-if="scope.row.isAuditing == 1">审核中</el-tag>
          <el-tag type="info" v-else>拒绝</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="失败原因" prop="reason"></el-table-column>
       <el-table-column label="创建时间" prop="createtimeStr"></el-table-column>
      <el-table-column label="操作" fixed="right" width="90">
        <template slot-scope="scope">
          <span class="text-blue pointer" @click="revise(scope.row)" v-if="scope.row.isAuditing !=0 ">修改 | </span>
          <span class="text-red pointer" @click="deleteRow(scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="block mtop20">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size=pageSize
        layout="total, sizes, prev, pager, next, jumper"
        :total=total>
      </el-pagination>
    </div>
    <creat v-if="show" @closeComponent='close' :data='reviseData'></creat>
  </div>
</template>
<script>
import tips from '../../components/message/tips'
import creat from '../../components/message/creatAutograph'
import api from '../../server/api.js'
export default {
  name: "autographList",
  data(){
    return{
      pageSize: 10,//当前显示条数
      pageNum: 1,//当前页数
      total: 0,//总数
      autographData: [],
      show: false,
      reviseData: null,
    };
  },
  created(){
    this.getAutographList();
  },
  methods: {
    getAutographList(){//获取签名列表
      let data = {
        "start": this.pageNum,
        "length": this.pageSize,
        // "signName": 
        // "mouldSign": 
        // "mouldName": 
        // "isAuditing": 
      }
      api.autographList({data:data}).then(res => {
        if(res.status == 'success'){
          this.autographData = res.data.resultList;
          this.total = res.data.count;
        }
      })
    },
    creatAutograph(){//创建签名
    this.reviseData = null;
      this.show = true;
    },
    revise(row){//修改签名
      this.reviseData = row;
      this.show = true;
    },
    close(){//关闭创建
      this.show = false;
      this.getAutographList();
    },
    deleteRow(row,index){//删除签名
      this.$confirm('此操作将永久删除该签名, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let arr = [];
        arr[0] = row.signSign;
        api.delAutograph({data:{"signSignList": arr}}).then(res =>{
          if(res.status == 'success'){
            this.$message.success(res.msg);
            this.autographData.splice(index,1)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },
    sizeChange(v){//切换显示条数
      this.pageSize = v;
      this.getAutographList();
    },
    currentChange(v){//切换页数
      this.pageNum = v;
      this.getAutographList();
    },
  },
  components: {
    tips,creat,
  }
}
</script>
  




// WEBPACK FOOTER //
// src/view/message/autographList.vue